@if (hasSelectableLayers()) {
    @if (shouldDisplayPreselection()) {
        <div
            class="flex flex-row pb-2 w-fit cursor-pointer"
            [matTooltip]="isLayerPreselectionEnabled() ? ('depositNotStandardized' | transloco) : ''"
            (click)="handlePreselection.emit()">
            <app-checkbox
                [checkboxState]="isLayerPreset() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED"
                [disabled]="isLayerPreselectionEnabled()" />
            <span class="pl-2 custom-text text-custom-extra-dark-grey">{{ 'preselectLayers' | transloco }}</span>
        </div>
    }
    <span class="custom-text">{{ 'layer' | transloco }}</span>
    <div class="w-full pb-6">
        <app-select
            [defaultValue]="defaultLayers()"
            [isMultiSelect]="true"
            [options]="addLayerService.tableOptions()"
            [placeholder]="'selectOneOrMoreLayers'"
            (optionSelected)="selectTable($event)" />
    </div>
} @else if (isTableLoading()) {
    <app-loading />
} @else {
    <span class="custom-text">{{ 'noDepositLayer' | transloco }}</span>
}
